module.exports = "/_next/static/images/8-1-2df2ff65547e7a593f006c65fd99a6d8.svg";